import React, { useEffect, useState } from 'react';

/**
 * Full-screen Windows-XP boot splash.
 * Unmounts itself after 2 000 ms.
 */
const BootSplash = () => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const id = setTimeout(() => setShow(false), 2000);   // 2 s
    return () => clearTimeout(id);
  }, []);

  if (!show) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 9999,
        background: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src="/xp-boot.gif"
        alt="Windows XP booting"
        style={{ maxWidth: '90%', height: 'auto' }}
      />
    </div>
  );
};

export default BootSplash;